import React from 'react'
import { isMobile } from 'react-device-detect'
import SaveIcon from 'client/utils/icons/save-icon'
import {
  $DCprimaryColor,
  DcButton,
  DcDiv,
  DcDropDown,
  DcIcon,
  DcInput,
  DcText,
  PixelDiv,
  PixelDropZone,
  PixelFactoryContext,
  PixelFlexBox,
  PixelImage,
  PixelModal,
  Section,
  SectionContent,
  SectionForm,
  SectionTitle,
} from 'pixel-base'
import styled from 'styled-components'

import { get, put, uploadCustomerLogo } from 'utils/api-routes.util'
import UploadIcon from 'utils/icons/upload-icon'

import dummyLogo from './dummyLogo.png'
import { IPixelFactory } from '../../../../../../decl.d'

const fields = [
  {
    name: 'Company Name',
    key: 'company_name',
    type: 'text',
  },
  {
    name: 'Phone Number',
    key: 'company_phone_number',
    type: 'text',
  },
  {
    name: 'Website',
    key: 'company_website',
    type: 'text',
  },
  {
    name: 'Email',
    key: 'company_email',
    type: 'text',
  },
  {
    name: 'WhatsApp Number',
    key: 'whatsapp_number',
    type: 'text',
  },
  {
    name: 'Company Address',
    key: 'company_address',
    type: 'text',
  },
  {
    name: 'Company City',
    key: 'company_city',
    type: 'text',
  },
  {
    name: 'Company State/Province',
    key: 'company_state',
    type: 'text',
  },
  {
    name: 'Country',
    key: 'company_country',
    type: 'select',
  },
  {
    name: 'Zip Code',
    key: 'company_zip',
    type: 'text',
  },
]

export const CompanyInfo = ({ countries }) => {
  const {
    showLoader,
    hideLoader,
    showSuccess,
    showFailure,
    showPageLoader,
    hidePageLoader,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)

  const mainSectionRef = React.useRef(null)
  const [data, setData] = React.useState({
    company_name: '',
    company_phone_number: '',
    company_website: '',
    company_email: '',
    whatsapp_number: '',
    company_address: '',
    company_city: '',
    company_country: '',
    company_zip: '',
    company_state: '',
  })

  const [isOpen, setIsOpen] = React.useState(false)
  const [logo, setLogo] = React.useState('')
  const [updatedLogo, setUpdatedLogo] = React.useState('')
  const [file, setFile] = React.useState({
    attachment: null,
  })
  const [error, setError] = React.useState({ error: '', field: '' })
  React.useEffect(() => {
    readData()
  }, [])

  const readData = () => {
    showLoader(mainSectionRef)
    get('/tenant/company').subscribe((res: any) => {
      hideLoader(mainSectionRef)
      setData({
        company_name: res.response?.company_name,
        company_phone_number: res.response?.company_phone_number,
        company_website: res.response?.company_website,
        company_email: res.response?.company_email,
        whatsapp_number: res.response?.whatsapp_number,
        company_address: res.response?.company_address,
        company_city: res.response?.company_city,
        company_country: res.response?.company_country,
        company_zip: res.response?.company_zipcode,
        company_state: res.response?.company_state,
      })
      setLogo(res.response?.logo?.attachment_path)
    })
  }

  const updateData = () => {
    showLoader(mainSectionRef)
    put('/tenant/company', data).subscribe((res: any) => {
      hideLoader(mainSectionRef)
      if (res.response) {
        setData({
          company_name: res.response?.company_name,
          company_phone_number: res.response?.company_phone_number,
          company_website: res.response?.company_website,
          company_email: res.response?.company_email,
          whatsapp_number: res.response?.whatsapp_number,
          company_address: res.response?.company_address,
          company_city: res.response?.company_city,
          company_country: res.response?.company_country,
          company_zip: res.response?.company_zipcode,
          company_state: res.response?.company_state,
        })
        showSuccess('Updated Successfully')
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }

  const updateAllCompanyInfo = (e) => {
    e.preventDefault()
    updateData()
  }

  const handleUpload = () => {
    showPageLoader()
    uploadCustomerLogo(file.attachment).subscribe((res: any) => {
      setUpdatedLogo(res.response.logo.attachment_path)
      readData()
      setIsOpen(false)
      hidePageLoader()
      showSuccess('Updated Successfully')
    })
  }
  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <Section isMobile={isMobile}>
      <PixelModal
        title="Upload Logo"
        handleClose={() => setIsOpen(false)}
        show={isOpen}
        size="md"
      >
        <PixelFlexBox
          gap="10px"
          style={{ marginBottom: '10px' }}
          alignItem="center"
          flexDirection="row"
          justifyContent="center"
        >
          <PixelDropZone
            required
            onChange={(files) => {
              setFile({ ...file, attachment: files[0] })
            }}
          />
        </PixelFlexBox>
        <PixelFlexBox
          gap="10px"
          style={{ marginBottom: '10px' }}
          alignItem="center"
          flexDirection="row"
          justifyContent="flex-end"
        >
          <DcButton size="sm" variant="outline-secondary" onClick={handleClose}>
            Cancel
          </DcButton>
          <DcButton size="sm" variant="primary" onClick={handleUpload}>
            Uplaod
          </DcButton>
        </PixelFlexBox>
      </PixelModal>
      <PixelDiv margin="0 0 15px 0">
        <PixelFlexBox
          alignItems="flex-end"
          marginBottm="25px"
          alignContent="flex-start"
          gap="15px"
          width="100%"
          height="100%"
          position="relative"
        >
          <PixelImage
            src={updatedLogo || logo || dummyLogo}
            width="75px"
            height="75px"
            backgroundColor="#fff"
            borderRadius="50%"
            boxShadow="0 0 5px rgba(0, 0, 0, 0.1)"
            style={{
              cursor: 'pointer',
            }}
            hoverStyle={`
                        &:hover + ${UploadLogo} {
                          display: block;
                          z-index: 10;
                        }
                       `}
          />
          <UploadLogo
            onClick={() => {
              setIsOpen(true)
            }}
          >
            <UploadIcon size={18} color={$DCprimaryColor} />
          </UploadLogo>
          <SectionTitle>Company Info</SectionTitle>
        </PixelFlexBox>
      </PixelDiv>

      <SectionContent
        isMobile={isMobile}
        className="general-info-container"
        ref={mainSectionRef}
      >
        <SectionForm
          isMobile={isMobile}
          onSubmit={updateAllCompanyInfo}
          columnItems="2"
        >
          {fields.map((field) => {
            return (
              <PixelDiv key={field.key}>
                <PixelDiv>
                  {field.type === 'text' ? (
                    <DcDiv
                      width="100%"
                      height="auto"
                      style={{
                        display: 'flex',

                        flexDirection: 'column',
                        alignItems: 'flexStart',
                      }}
                    >
                      <DcText
                        style={{
                          textAlign: 'left',

                          color: '#2e314a',
                          fontSize: '.875rem',
                          fontWeight: '500',
                          marginBottom: '.5rem',
                        }}
                      >
                        {field.name}
                      </DcText>
                      <DcInput
                        error={
                          error.field === field.key && error.error !== ''
                            ? error.error
                            : null
                        }
                        required
                        type={field.type}
                        name={field.key}
                        placeholder={field.name}
                        value={data[field.key]}
                        tabIndex={1}
                        onChange={(e) =>
                          setData({ ...data, [field.key]: e.target.value })
                        }
                      />
                    </DcDiv>
                  ) : (
                    <DcDiv
                      width="100%"
                      height="auto"
                      style={{
                        display: 'flex',

                        flexDirection: 'column',
                        alignItems: 'flexStart',
                      }}
                    >
                      <DcText
                        style={{
                          textAlign: 'left',

                          color: '#2e314a',
                          fontSize: '.875rem',
                          fontWeight: '500',
                          marginBottom: '.5rem',
                        }}
                      >
                        {field.name}
                      </DcText>
                      <DcDropDown
                        placeholder="Select Country"
                        tabIndex={1}
                        error={
                          error.field === field.key && error.error !== ''
                            ? error.error
                            : null
                        }
                        required
                        options={[...countries].map((data) => {
                          return {
                            label: data.label,
                            value: data.two_letter_abbreviation,
                          }
                        })}
                        value={data[field.key]}
                        onChange={(e) => {
                          setData({ ...data, [field.key]: e.target.value })
                        }}
                      />
                    </DcDiv>
                  )}
                </PixelDiv>
              </PixelDiv>
            )
          })}

          <PixelDiv>
            <DcButton size="sm" variant="primary" type="submit" withIcon={true}>
              <SaveIcon size={16} />
              <span>Save</span>
            </DcButton>
          </PixelDiv>
        </SectionForm>
      </SectionContent>
    </Section>
  )
}

const UploadLogo = styled(DcButton)`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 75px;
  height: 75px;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.5) !important;
  border: none;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  z-index: 1;
  cursor: pointer;
  &:hover {
    z-index: 10;
    display: block;
    background-color: rgba(0, 0, 0, 0.5) !important;
  }
`
